import helper from '../js/helper';

export default function logger(...messages) {
  const logParam = helper.getURLParameter('log');

  if (logParam === '1' || logParam === 'true') {
	// check if the first argument is a log type
	let type = 'log';
	if (['error', 'warn', 'info', 'debug'].includes(messages[0])) {
	  type = messages.shift(); // remove type from the array
	}

	// prepend "LOG:" only for strings
	const prefix = 'LOG:';
	console[type](prefix, ...messages); 
  }
}
